export default {
  title: 'Ups!',
  desc: 'Coś poszło nie tak, kliknij przycisk aby przejść do strony głównej.',
  desc2: 'Coś poszło nie tak, kliknij przycisk aby wrócić do poprzedniej strony.',
  noPreviewDesc: 'Podgląd niedostępny - uczeń nie ma nadanego dostępu do ES Online',
  button: 'Powrót do strony głównej',
  button2: 'Powrót do poprzedniej strony',
};
